var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAndusSystemRouterUnityLearningIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 96,
    rx: 26,
    fill: "#EAF5FC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m24 40 24-14 24 14-24 14-24-14Z",
    stroke: "#287EB7",
    strokeWidth: 5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32 48v17c10 7 22 7 32 0V48",
    stroke: "#287EB7",
    strokeWidth: 5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAndusSystemRouterUnityLearningIcon);
export default __webpack_public_path__ + "static/media/andus-system-router-unity-learning-icon.494114b5e7078f3c912f17e171a08d76.svg";
export { ForwardRef as ReactComponent };